import React, { useEffect, useState } from "react";
import {
  deleteTestSeriesQuestion,
  updateSingleQuestionMarks,
  updateTestSeriesQuestionStatus,
} from "../../../api/testSeries/testseries";
import QuestionLanguageVarient from "./QuestionLanguageVarient";
import Snackbar from "@material-ui/core/Snackbar";
import Modal from "react-bootstrap/Modal";
import ClipLoader from "react-spinners/ClipLoader";
import { BsFillBookmarkCheckFill, BsBookmarkDash } from "react-icons/bs";
import { save_for_later_api, verify_changes_api } from "../../../api/testSeries/category";

function Question({
  item,
  deleteSectionQuestionAtIndex,
  index,
  updatePublishedQuestionCount,
  publishedQuestionCount,
  totalQuestionToBePublished,
  activeSection,
  updateItemStatusAtIndex,
}) {
  const [changesVerified,setChangesVerified] = useState();
  const [activeLanguageIndex, setActiveLanguageIndex] = useState(0);
  const [questionData, setQuestionData] = useState(item);
  const [publishedStatus, setPublishedStatus] = useState(item.published);
  const [editQuestionMarksModalVisible, setEditQuestionMarksModalVisible] =
    useState(false);
  const [SnackBarMessage, setSnackBarMessage] = useState("");
  const [isSnackBarShow, setIsSnackBarShow] = useState(false);
  const [editQuestionMarksData, setEditQuestionMarksData] = useState({});
  const [editingQuestionMarks, setEditingQuestionMarks] = useState(false);
  const [saveForLater, setSaveForLater] = useState(item?.savedForLater);
  const updateActiveLanguageQuestionData = (updatedQuestionData) => {
    console.log("updated question", updatedQuestionData);
    const obj = { ...questionData };
    obj.questionLanguageVarients[activeLanguageIndex] = updatedQuestionData;
    setQuestionData(obj);
  };

  const [ocrConvertedQuestion, setOcrConvertedQuestion] = useState("");

  const closeSnack = () => {
    setIsSnackBarShow(false);
  };
  useEffect(() => {
    setQuestionData(item);
    setChangesVerified(item.isInternSubmissionVerified)
  }, [item]);

  const handleDeleteQuestion = () => {
    if (window.confirm("Are you sure you want to delete this question?")) {
      deleteTestSeriesQuestion(
        questionData.id,
        index,
        deleteSectionQuestionAtIndex
      );
    }
  };

  const handleChangeQuestionStatus = async (changedStatus) => {
    const response = await updateTestSeriesQuestionStatus(
      questionData.id,
      changedStatus,
      activeSection?.id
    );
    if (response.status) {
      updatePublishedQuestionCount(changedStatus);
      setPublishedStatus(changedStatus);
      updateItemStatusAtIndex(index, changedStatus);
    }
  };

  const editQuestionMarksHandler = (e) => {
    e.preventDefault();
    setEditingQuestionMarks(true);
    const marksObj = {};
    marksObj.posMarks = parseInt(editQuestionMarksData.posMarks);
    marksObj.negMarks = editQuestionMarksData.isNegativeMarking
      ? parseInt(editQuestionMarksData.negMarks)
      : 0;
    marksObj.negMarksUnattempted = editQuestionMarksData.isNegativeMarking
      ? parseInt(editQuestionMarksData.negMarksUnattempted)
      : 0;
    marksObj.questionId = item.id;
    updateSingleQuestionMarks(marksObj, (response) => {
      if (response.status === 200) {
        console.log("updated");
      }
    });
    setEditQuestionMarksModalVisible(false);
    setEditingQuestionMarks(false);
  };

  const handleEditQuestionMarksDataInput = (e) => {
    const obj = { ...editQuestionMarksData };
    obj[e.target.name] = e.target.value;
    setEditQuestionMarksData(obj);
  };

  const editMarksBtnHandler = () => {
    const obj = { ...editQuestionMarksData };

    obj.posMarks = questionData.posMarks;
    if (questionData.negMarks) {
      obj.negMarks = questionData.negMarks;
      obj.isNegativeMarking = true;
      obj.negMarksUnattempted = questionData.negMarksUnattempted;
    }
    setEditQuestionMarksData(obj);
    setEditQuestionMarksModalVisible(true);
  };

  const SaveForLaterHandler = async (status) => {
    const response = await save_for_later_api({ status, id: item?.id });

    if (response.status) {
      setSnackBarMessage(
        status ? "Saved Successfully!" : "Unsaved Successfully!"
      );
      setIsSnackBarShow(true);
      setSaveForLater(status);
    } else {
      setSnackBarMessage("Something went wrong!");
      setIsSnackBarShow(true);
    }
  };

  const verifyChanges = async ()=>{
    const response  = await verify_changes_api(item?.id,true)
    if(response.status){
    setChangesVerified(true)
    }else{
      setSnackBarMessage("Something went wrong!");
      setIsSnackBarShow(true);
    }
  }

  // console.log("ocrConvertedQuestion", ocrConvertedQuestion);
  return (
    <div className="mt-1">
      <div className="row">
        <div className="col-6"></div>
        <div className="col-6">
          <button
            type="button"
            class="btn btn-danger mr-3"
            onClick={() => {
              handleDeleteQuestion();
            }}
          >
            Delete
          </button>
          {!changesVerified ? (
            <button
              type="button"
              class="btn btn-success mr-3"
              onClick={() => {
                verifyChanges()
              }}
            >
              Verify Intern Changes
            </button>
          ) : (
            <button
              type="button"
              class="btn btn-danger mr-3"
             
            >
              Changes Verified
            </button>
          )}
       
          {/* {!publishedStatus ? (
            <button
              type="button"
              class="btn btn-dark mr-3"
              onClick={() => {
                if (publishedQuestionCount == totalQuestionToBePublished) {
                  setSnackBarMessage(
                    "You Have Reached the limit. Cannot Publish More Questions."
                  );
                  setIsSnackBarShow(true);
                } else {
                  handleChangeQuestionStatus(true);
                }
              }}
            >
              PUBLISH
            </button>
          ) : (
            <button
              type="button"
              class="btn btn-danger mr-3"
              onClick={() => handleChangeQuestionStatus(false)}
            >
              UNPUBLISH
            </button>
          )} */}
          {/* <button
            type="button"
            class="btn btn-warning mr-3"
            data-toggle="modal"
            data-target="#editQuestionMarksModal"
            onClick={() => {
              editMarksBtnHandler();
            }}
          >
            Edit Marks
          </button> */}
          {/* <button
            type="button"
            class="btn btn-warning mr-3"
            data-toggle="modal"
            data-target="#editQuestionMarksModal"
            onClick={() => {
              SaveForLaterHandler(!saveForLater);
            }}
          > */}
            {/* <BookmarkBorderIcon sx={{ height: "20px" }} /> Save For Later */}
            {/* {saveForLater ? <BsFillBookmarkCheckFill /> : <BsBookmarkDash />}
          </button> */}
        </div>
      </div>
      <div className="row">
        <span className="ml-2 mr-4" style={{ fontWeight: 700 }}>
          {index + 1}
        </span>
        <span style={{ flex: 0.9 }}>
          <QuestionLanguageVarient
            ocrConvertedQuestion={ocrConvertedQuestion}
            setOcrConvertedQuestion={setOcrConvertedQuestion}
            updateActiveLanguageQuestionData={updateActiveLanguageQuestionData}
            index={index}
            queData={item}
            item={questionData.questionLanguageVarients[activeLanguageIndex]}
            setEditQuestionMarksModalVisible={setEditQuestionMarksModalVisible}
            editQuestionMarksModalVisible={editQuestionMarksModalVisible}
          />
        </span>
      </div>

      <Modal
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
        show={editQuestionMarksModalVisible}
        onHide={() => setEditQuestionMarksModalVisible(false)}
      >
        <form onSubmit={editQuestionMarksHandler}>
          <Modal.Header>
            <h5 className="modal-title">Add Question</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              {" "}
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="form-row mt-2">
                <div className="col-12">
                  <label>Marks per question</label>
                  <input
                    required
                    type="number"
                    className="form-control"
                    value={editQuestionMarksData["posMarks"]}
                    name={"posMarks"}
                    placeholder="Marks"
                    onChange={handleEditQuestionMarksDataInput}
                  />
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Negative Marking</label>
                  <input
                    type="checkbox"
                    className="form-control"
                    value={editQuestionMarksData["isNegativeMarking"]}
                    checked={editQuestionMarksData["isNegativeMarking"]}
                    placeholder="Negative Marks"
                    name={"isNegativeMarking"}
                    onChange={(e) =>
                      handleEditQuestionMarksDataInput({
                        target: {
                          name: "isNegativeMarking",
                          value: !editQuestionMarksData["isNegativeMarking"],
                        },
                      })
                    }
                  />
                </div>
              </div>

              {editQuestionMarksData["isNegativeMarking"] ? (
                <div className="form-row mt-2">
                  <div className="col-6">
                    <label>Negative Marks per question</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editQuestionMarksData["negMarks"]}
                      name={"negMarks"}
                      placeholder="Marks"
                      onChange={handleEditQuestionMarksDataInput}
                    />
                  </div>
                  <div className="col-6">
                    <label>Negative Marks per question if unattempted</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editQuestionMarksData["negMarksUnattempted"]}
                      name={"negMarksUnattempted"}
                      placeholder="Marks"
                      onChange={handleEditQuestionMarksDataInput}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setEditQuestionMarksModalVisible(false)}
              data-dismiss="modal"
            >
              Close
            </button>
            <button className="btn btn-primary" disabled={editingQuestionMarks}>
              {editingQuestionMarks ? (
                <ClipLoader
                  color="white"
                  loading={editingQuestionMarks}
                  size={20}
                />
              ) : (
                "Save Changes"
              )}
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      <hr />
      <Snackbar
        open={isSnackBarShow}
        onClose={(e) => closeSnack(e)}
        TransitionComponent="TransitionUp"
        message={SnackBarMessage}
      />
    </div>
  );
}

export default Question;
